let func = null;
export default function useMenu(name)
{
    return func(null, name)
}

export function setFunc(f)
{
    func = f;
}